<template>
    <form class="cosmos-form">
        <div class="grid-x grid-padding-x">
            <div class="medium-8 cell">
                <div v-for="(fld, index) in state.fields" class="holder">
                    <p>
                        <input ref="ins" :type="fld.type" :id="fld.fldname" v-model="fld.value" :name="fld.fldname" :placeholder="fld.placeholder + (fld.required ? '*' : '')" :aria-label="fld.placeholder" />
                    </p>
                    <p v-if="fld.error" class="error">{{ fld.error }}</p>
                </div>
            </div>
            <div class="cell">
                <p><input type="submit" class="button form-post-button" @click.prevent="checkForm($event)" name="submit" value="Sign me in" /></p>
                <p v-if="state.result" class="error" v-html="state.result"></p>
            </div>
            <div class="cell" style="margin:2rem 0;">
                <p><strong>Forgotten your password?</strong> Don’t worry, its easily done; simply <a href="/account/forgotpassword">click here to reset it</a>.</p>
            </div>
        </div>
    </form>
</template>
<script setup>
    import { ref, onMounted, nextTick, reactive } from 'vue'
    import RendiliCore from '@RendiliCore'

    const emit = defineEmits(['logged-in']);
    const props = defineProps({
        'redirect': {
            type: Boolean,
            default: false
        },
        'isbasket': {
            type: Boolean,
            default: false
        },
        'modal': {
            type: Boolean,
            default: false
        }
    })

    const state = reactive({
        fields: [
            {'type' : 'email', 'name' : 'email' , 'placeholder' : 'email','required' : true, 'value' : '', 'error' : ''},
            {'type' : 'password', 'name' : 'password' , 'placeholder' : 'password','required' : true,'value' : '', 'error' : ''},
        ],
        result: '',
        haserrors: false
    })

    defineOptions({
        name: 'SignIn'
    })

    function checkForm(e) {
        e.preventDefault();
        state.haserrors = false;

        state.fields.forEach(function (fld, index) {
            fld.error = '';
            if(fld.required && !fld.value) {
                fld.error = 'This field is required'
                state.haserrors = true
            }
        });

        if (!validEmail(state.fields[0].value)) {
            state.fields[0].error = 'Valid email is required.'
            state.haserrors = true
        }

        if (!state.haserrors) {
            submitForm()
        }
    }

    function validEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    function submitForm() {
        state.result =  ''
        RendiliCore.Json.PostJsonData({
            url: '/alternative/account/signin',
            data: {
                email: state.fields[0].value,
                password: state.fields[1].value,
                redirect: props.redirect,
                inbasket: props.isbasket
            }
        })                   
        .then(function (data) {
            if(data.status == "Error") {
                state.result = data.message;
            } else {
                state.result = "";
                emit('logged-in', { user_type: data.user_type });
                gtag_ecom("event", "login", {});
                if(props.redirect) {
                    window.location.replace(props.redirect);
                } else if (props.modal) {
                    $('#signinModal').foundation('close');
                }
            }
        })
    }

    onMounted(() => {
        nextTick(() => {
            //this.$refs.ins[0].focus()
        })
    })
</script>